import { APIClient, ApiQueryParams } from '@frontend/api-utils';
import { EventListResponse, EventQueryParams } from '@frontend/events/types';

export class EventClient extends APIClient {
    public static readonly endpoint = '/event-api/v1';

    public static async fetchEntityEvents(entityType: string, entityId: string, queryParams?: ApiQueryParams<EventQueryParams>): Promise<EventListResponse> {
        return await this.apiPaginated<EventListResponse, EventQueryParams>(`${this.endpoint}/${entityType}s/${entityId}/events`, queryParams);
    }

    public static async fetchEvents(queryParams?: ApiQueryParams<EventQueryParams>): Promise<EventListResponse> {
        return await this.apiPaginated<EventListResponse, EventQueryParams>(`${this.endpoint}/events`, queryParams);
    }
}
